/* @flow */

import React from 'react';
import { Col, Input, Table, FormGroup } from 'reactstrap';
// import _ from 'lodash';

// import RevertInput from '../RevertInput';

// import cx from 'classnames';
// import classes from './DropdownWithPanel.scss';
// import fieldWrapperClases from '../FieldWrapper/FieldWrapper.scss';

type OptionType = {
  construction: string,
  description: string,
  device: string,
  id: number,
  iSwtch: number,
  partDimensions: string,
  partNumber: string,
  rthJcD: number,
  rthJcQ: number,
  tjMax: number,
  vSwtch: number,
};

type PropsType = {
  changed: boolean,
  changeInput: Function,
  defaultVal: string | number,
  error: string[],
  fieldName: string | React$Element<*>,
  options: Array<any>,
  revertInput: Function,
  tooltip: string | React$Element<*>,
  value: string | number,
};

export class DropdownWithPanel extends React.PureComponent<PropsType, *> {
  static defaultProps = {
    options: [],
    fieldName: <div />,
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const options: OptionType[] = this.props.options;

    const renderTable = (data: OptionType) => (
      <Table striped bordered size="sm" key={data.partNumber}>
        <tbody>
          <tr>
            <td style={{ width: '50%' }}>Selected Part</td>
            <td>{data.description}</td>
          </tr>
          <tr>
            <td style={{ width: '50%' }}>Package Dimensions</td>
            <td>{data.partDimensions}</td>
          </tr>
          <tr>
            <td style={{ width: '50%' }}>Construction</td>
            <td>{data.construction}</td>
          </tr>
          <tr>
            <td style={{ width: '50%' }}>Switching Device</td>
            <td>{data.device}</td>
          </tr>
          <tr>
            <td style={{ width: '50%' }}>Current Rating (A)</td>
            <td>{data.iSwtch}</td>
          </tr>
          <tr>
            <td style={{ width: '50%' }}>R<sub>th(J-C)</sub> IGBT/MOSFET (°C/W)</td>
            <td>{data.rthJcQ}</td>
          </tr>
          <tr>
            <td style={{ width: '50%' }}>R<sub>th(J-C)</sub> Diode (°C/W)</td>
            <td>{data.rthJcD}</td>
          </tr>
          <tr>
            <td style={{ width: '50%' }}>Max T<sub>j</sub> rating (°C)</td>
            <td>{data.tjMax}</td>
          </tr>
        </tbody>
      </Table>
    );

    // const canRevert = this.props.changed || this.props.value !== this.props.defaultVal;

    // const getRevertNameFromValue: () => string = (): string => {
    //   const val = this.props.defaultVal;
    //   const opt = this.props.options.find(i => i.key === val);
    //   const short: string = _.get(opt, ['display']);
    //   const name: string = _.get(opt, ['name'], val);
    //   return short || name;
    // };

    // const recommendedDiv = (
    //   <RevertInput
    //     className={fieldWrapperClases.inputGroupDefault}
    //     value={getRevertNameFromValue()}
    //     enable={canRevert}
    //     onClick={this.props.revertInput}
    //   />
    // );

    const selected = options.find(i => i.partNumber === this.props.value);
    return (
      <Col sm={12}>
        <div className="d-flex">{this.props.fieldName}{this.props.tooltip}</div>
        <FormGroup>
          <Input
            type="select"
            name="selectMulti"
            onChange={this.props.changeInput}
            defaultValue={this.props.value}
          >
            {options.map(i => <option key={i.id} value={i.partNumber}>{i.description}</option>)}
          </Input>
        </FormGroup>
        <div>{selected && renderTable(selected)}</div>
      </Col>
    );
  }
}

export default DropdownWithPanel;



// WEBPACK FOOTER //
// ./src/components/DropdownWithPanel/DropdownWithPanel.js